// src/components/tabs/AnalyticsTab.jsx
import React from 'react';
import { BarChart3, TrendingUp, Activity, DollarSign } from 'lucide-react';
import Hero from '../shared/Hero';

const AnalyticsTab = ({ stats }) => {
  return (
    <div>
      {/* Hero institucional */}
      <Hero
        title="Análises & KPIs"
        subtitle="Insights financeiros automáticos"
        icons={['/icons/passport-pt.png', '/icons/document-eu.png', '/icons/globe.png']}
      />

      {/* Conteúdo */}
      <div className="bg-white rounded-xl p-6 border border-gray-100">
        <h3 className="text-lg font-semibold text-gray-900 mb-6 flex items-center gap-2">
          <BarChart3 className="w-5 h-5 text-indigo-600" />
          Analytics & Insights
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="p-5 rounded-xl bg-gradient-to-br from-green-50 to-green-100">
            <div className="flex items-center gap-3 mb-3">
              <DollarSign className="w-6 h-6 text-green-600" />
              <span className="text-sm font-medium text-gray-700">Total Amount</span>
            </div>
            <p className="text-2xl font-bold text-gray-900">
              {new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(
                stats.totalAmount || 0
              )}
            </p>
            <p className="text-xs text-gray-600 mt-1">Somatório de todas as faturas</p>
          </div>

          <div className="p-5 rounded-xl bg-gradient-to-br from-blue-50 to-blue-100">
            <div className="flex items-center gap-3 mb-3">
              <Activity className="w-6 h-6 text-blue-600" />
              <span className="text-sm font-medium text-gray-700">Invoices Processed</span>
            </div>
            <p className="text-2xl font-bold text-gray-900">
              {stats.pending + stats.validated + stats.exported}
            </p>
            <p className="text-xs text-gray-600 mt-1">Total de faturas registradas no sistema</p>
          </div>

          <div className="p-5 rounded-xl bg-gradient-to-br from-purple-50 to-purple-100">
            <div className="flex items-center gap-3 mb-3">
              <TrendingUp className="w-6 h-6 text-purple-600" />
              <span className="text-sm font-medium text-gray-700">Match Rate</span>
            </div>
            <p className="text-2xl font-bold text-gray-900">{stats.matchRate}%</p>
            <p className="text-xs text-gray-600 mt-1">Percentual de faturas reconciliadas</p>
          </div>

          <div className="p-5 rounded-xl bg-gradient-to-br from-amber-50 to-amber-100">
            <div className="flex items-center gap-3 mb-3">
              <BarChart3 className="w-6 h-6 text-amber-600" />
              <span className="text-sm font-medium text-gray-700">Overview</span>
            </div>
            <p className="text-2xl font-bold text-gray-900">
              {stats.validated} / {stats.pending + stats.validated} validated
            </p>
            <p className="text-xs text-gray-600 mt-1">Progresso geral de validação</p>
          </div>
        </div>

        {/* placeholder p/ gráfico futuro */}
        <div className="mt-10 bg-gray-50 rounded-xl p-8 text-center text-gray-500">
          <BarChart3 className="w-10 h-10 mx-auto mb-3 text-gray-400" />
          <p className="font-medium">Em breve: gráficos detalhados de evolução</p>
          <p className="text-sm">Podemos integrar com Recharts para visualização temporal e tendências.</p>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsTab;
